import { Popover } from 'antd'
import WizrButton from '../WizrButton'
import MoreIcon from '../../assets/icons/More'
import EditIcon from '../../assets/icons/EditIcon'
import DeleteIcon from '../../assets/icons/DeleteIcon'
import { useWizrModalContext, MODAL_TYPES } from '../../providers/modal/WizrModalProvider'
import WizrFlexLayout from '../../components/WizrFlexLayout'
import styled from 'styled-components'
import { useState } from 'react'
import { dispatchAddNewReports, dispatchGetReportsForControlRoom, dispatchDeleteReport, dispatchGetControlRoomDiscoverScreenGetColumns } from '../../redux/actions/content'

interface IReportActionPopOver {
  detail: any
}

interface IReportActionPopOverContent {
  onEditAction: () => void
  onDeleteAction: () => void
}

const ReportActionPopOverContent = ({
  onEditAction,
  onDeleteAction
}: IReportActionPopOverContent): JSX.Element => {
  return (
    <WizrFlexLayout textAlign='left' background='#FFF'>
      <WizrButton
        icon={<EditIcon />}
        text='Edit'
        type='text'
        onClick={onEditAction}
        justifyContent='flex-start'
      />
      <WizrButton
        icon={<DeleteIcon />}
        text='Delete'
        type='text'
        onClick={onDeleteAction}
        justifyContent='flex-start'
      />
    </WizrFlexLayout>
  )
}

const ReportActionPopOver = ({ detail }: IReportActionPopOver): JSX.Element => {
  const { showModal, hideModal } = useWizrModalContext()
  const [popoverVisible, setPopoverVisible] = useState(false)

  const onEdit = async () => {
    // Close the popover immediately when edit is clicked
    setPopoverVisible(false)
    
    try {
      // First fetch dependent filter values
      await dispatchGetControlRoomDiscoverScreenGetColumns();
      
      showModal(MODAL_TYPES.CREATE_REPORTS, {
        onFormSubmission: async (updatedData: any) => {
          console.log('report updated', updatedData);
          await dispatchAddNewReports(updatedData)
          await dispatchGetReportsForControlRoom({
            limit: 100,
            offset: 0
          })
          hideModal();
        },
        action: "edit",
        details: detail,
        onCancel: hideModal,
      })
    } catch (error) {
      console.error('Failed to fetch dependent data for report edit:', error);
    }
  }

  const onDelete = async () => {
    // Close the popover immediately when delete is clicked
    setPopoverVisible(false)
    
    try {
      await dispatchDeleteReport(detail.report_id);
      // Refresh the reports list after successful deletion
      await dispatchGetReportsForControlRoom({
        limit: 100,
        offset: 0
      });
    } catch (error) {
      console.error('Failed to delete report:', error);
    }
  }

  return (
    <Popover
      content={<ReportActionPopOverContent onDeleteAction={onDelete} onEditAction={onEdit} />}
      title=''
      trigger='click'
      open={popoverVisible}
      onOpenChange={setPopoverVisible}
    >
      <StyledButton icon={<MoreIcon />} text='' type='text' style={{height: '40px', width: '40px', borderRadius: '50px'}}/>
    </Popover>
  )
}

export default ReportActionPopOver

const StyledButton = styled(WizrButton)`
border-radius: 50%;
width: 20px;
height: 20px;
padding-right: 8px;
justify-content: center;
align-items: center;
  /* Default styles */
  path {
    stroke: #999B9F; /* Default stroke color */
    transition: stroke 0.3s ease; /* Smooth transition for color change */
  }

  /* Hover styles */
  &:hover path {
    stroke: #1D1F22
  }
`; 